// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as AppStore from "./AppStore.bs.js";

var state_context = React.createContext(AppStore.initialState);

var dispatch_context = React.createContext(function (_action) {
      
    });

function useAppDispatch(param) {
  return React.useContext(dispatch_context);
}

function useAppState(param) {
  return React.useContext(state_context);
}

function useAppSelector(selector) {
  var state = React.useContext(state_context);
  return React.useMemo((function () {
                return Curry._1(selector, state);
              }), [state]);
}

var provider = state_context.Provider;

function Store$StateProvider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
              value: value,
              children: children
            });
}

var StateProvider = {
  provider: provider,
  make: Store$StateProvider
};

var provider$1 = dispatch_context.Provider;

function Store$DispatchProvider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider$1, {
              value: value,
              children: children
            });
}

var DispatchProvider = {
  provider: provider$1,
  make: Store$DispatchProvider
};

export {
  state_context ,
  dispatch_context ,
  useAppDispatch ,
  useAppState ,
  useAppSelector ,
  StateProvider ,
  DispatchProvider ,
  
}
/* state_context Not a pure module */
